import { useState } from 'react';
import { useParams, useRouter } from '@tanstack/react-router';
import { BackButton } from '@/components/common/BackButton';
import { AdvancedFilterButton, FilterPanelCollapse } from '@/components/common/AdvancedFilter';
import { PageHeader } from '@/components/layout/PageHeader';
import { FIT_TO_SCREEN_PAGE_CLASS } from '@/components/layout/page.constants';
import { SurveySubmissionFilterPanel } from '../components/SurveySubmissionFilterPanel';
import { SurveySubmissionListTable } from '../components/SurveySubmissionListTable';
import { SurveySubmissionSummary } from '../components/SurveySubmissionSummary';
import { useSurveySubmissionFilters } from '../hooks/useSurveySubmissionFilters';

export function SurveySubmissionsPage() {
  const { surveyId } = useParams({
    from: '/_auth/feedback/surveys/$surveyId/submissions',
  });
  const router = useRouter();
  const controller = useSurveySubmissionFilters();
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  function goBack() {
    if (router.history.canGoBack()) {
      router.history.back();
    } else {
      void router.navigate({
        to: '/feedback/surveys/$surveyId',
        params: { surveyId },
      });
    }
  }

  return (
    <div className={FIT_TO_SCREEN_PAGE_CLASS}>
      <PageHeader
        title="Submissions"
        leading={<BackButton onClick={goBack} />}
        actions={
          <AdvancedFilterButton
            isOpen={isFilterOpen}
            activeCount={controller.activeFilterCount}
            onClick={() => setIsFilterOpen((wasOpen) => !wasOpen)}
          />
        }
      />

      <FilterPanelCollapse isOpen={isFilterOpen}>
        <SurveySubmissionFilterPanel filters={controller} />
      </FilterPanelCollapse>

      <SurveySubmissionSummary surveyId={surveyId} filters={controller.summaryQueryParams} />

      <SurveySubmissionListTable surveyId={surveyId} listQueryParams={controller.listQueryParams} />
    </div>
  );
}
